class AbstractCalculator {}
export default AbstractCalculator;